export default function ({ router, i18n }) {

  function legacyRouterMode ({ fullPath }, from, next) {
    if (fullPath.substr(0, 2) === '/#') {
      const path = fullPath.substr(2)
      next(path)
      return
    }
    next()
  }

  function skipHome(to, from, next) {
    if (to.name === 'home') {
      const locale = i18n.locale
      return next({ name: 'list', params: { locale } })
    }
    return next()
  }

  function setDefaultLocale(to, from, next) {
    if (!to.params.locale) {
      const locale = i18n.locale
      const name = to.name
      return next({ name, params: { ...to.params, locale }, query: to.query, replace: true })
    }
    return next()
  }

  router.beforeEach(legacyRouterMode)
  router.beforeEach(skipHome)
  router.beforeEach(setDefaultLocale)

  return router
}
